/**
 * Datei-Download-Helper für Blob-Antworten der API.
 *
 * Wird von /pages/Voranmeldung.js und /pages/Exports.js verwendet. Extrahiert
 * Filename aus Content-Disposition-Header, fällt zurück auf einen Default.
 *
 * Behandelt zusätzlich Fehler-Antworten, deren Body als Blob ankam (typisch bei
 * `responseType: 'blob'` und 4xx-Status mit JSON-Detail).
 */

/**
 * Erzeugt einen Browser-Download aus einer Axios-Blob-Response.
 *
 * @param {AxiosResponse} res    Axios-Response mit responseType:"blob"
 * @param {string} fallbackName  Fallback-Dateiname falls Header fehlt
 * @param {string} mimeType      MIME-Type (z.B. "application/zip")
 */
export function downloadBlob(res, fallbackName, mimeType = "application/octet-stream") {
  const blob = new Blob([res.data], { type: mimeType });
  const filenameMatch = res.headers?.["content-disposition"]?.match(/filename="?([^"]+)"?/);
  const filename = filenameMatch?.[1] || fallbackName;
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return filename;
}

/**
 * Versucht den Detail-String aus einem Blob-Error-Body zu extrahieren.
 * Wirft NICHT — fällt auf den Default-Detail zurück.
 */
export async function extractBlobError(error, defaultDetail = "Download fehlgeschlagen") {
  if (error?.response?.data instanceof Blob) {
    try {
      const text = await error.response.data.text();
      const parsed = JSON.parse(text);
      return parsed.detail || defaultDetail;
    } catch {
      return defaultDetail;
    }
  }
  return error?.response?.data?.detail || defaultDetail;
}
